import * as Yup from "yup";

export const validationSchema = Yup.object({
  from_address: Yup.string()
    .email("Invalid email address")
    .max(100, "Maximum characters reached")
    .required("From address is required"),
  to_address: Yup.string()
    .email("Invalid email address")
    .max(100, "Maximum characters reached")
    .required("To address is required"),
});
